import React, { lazy } from 'react';

export const HomePage = lazy(() => import('HomePage'));
export const FundUpdate = lazy(() => import('FundUpdate'));
export const Portfolio = lazy(() =>
  import('Portfolio').then((m) => {
    const C = m?.default;
    if (C && typeof C === 'function')
      (C as React.ComponentType & { displayName?: string }).displayName = 'Portfolio';
    return { default: C ?? (() => null) };
  }),
);
export const InvestorProvider = lazy(() =>
  import('InvestorProvider').then((module) => ({
    default: module.InvestorProvider,
  })),
);
export const AdvisorInvestorProvider = lazy(() =>
  import('AdvisorInvestorProvider').then((module) => ({
    default: module.AdvisorInvestorProvider,
  })),
);
export const NewFunds = lazy(() => import('NewFunds'));
export const NewFundsAdvisor = lazy(() => import('NewFundsAdvisor'));
export const PropertiesApplication = lazy(() => import('PropertiesApplication'));
export const PropertiesApplicationAdvisor = lazy(() => import('PropertiesApplicationAdvisor'));
export const PropertiesComingSoon = lazy(() => import('PropertiesComingSoon'));
export const PropertiesComingSoonAdvisor = lazy(() => import('PropertiesComingSoonAdvisor'));
export const PropertiesEOI = lazy(() => import('PropertiesEOI'));
export const PropertiesEOIAdvisor = lazy(() => import('PropertiesEOIAdvisor'));
export const EntityAssociationWizard = lazy(() =>
  import('../InvestmentEntity').then((module) => ({
    default: module.EntityAssociationWizard,
  })),
);
export const EntityAssociationPage = lazy(() => import('EntityAssociationPage'));
export const SettingsPage = lazy(() => import('SettingsPage'));
export const AdviceViewPage = lazy(() => import('AdviceViewPage'));
export const AcceptInvitationPage = lazy(
  () => import('../../components/Advisor/AcceptInvitationPage'),
);
export const RejectInvitationModal = lazy(
  () => import('../../components/Advisor/RejectInvitationModal'),
);
export const ConfirmEmailPage = lazy(() => import('../../pages/ConfirmEmailPage'));
export const ArticleView = lazy(() => import('ArticleView'));
export const FAQ = lazy(() => import('FAQ'));
export const ShareOpportunityPage = lazy(() => import('../../pages/ShareOpportunityPage'));
export const ReferralInvitationPage = lazy(() => import('../../pages/ReferralInvitationPage'));
